<script setup lang="ts">
import { computed, ref } from 'vue'
import ResizeHandle from '@/components/ResizeHandle.vue'
import { getScrollAreaHeight, resizableHeightStyle } from '@/services/functions'

type Props = {
  scrollAreaSelector?: string;
};

const props = defineProps<Props>()

const root = ref<HTMLElement | null>(null)
const height = ref<number | null>(null)

const heightStyle = computed(() => resizableHeightStyle(height.value))
function scrollAreaHeight(): number {
  return getScrollAreaHeight(root.value, props.scrollAreaSelector)
}
</script>

<template>
  <div class="resizable-list" ref="root" :style="heightStyle">
    <slot />
    <ResizeHandle
      :getHeight="scrollAreaHeight"
      v-model:height="height"
    />
  </div>
</template>
